import styles from 'components/sidebar/sidebar.module.css';
import { FCWithChildren } from 'utils/props';

export const Sidebar: FCWithChildren = ({ children }) => (
  <div className={styles.Sidebar}>{children}</div>
);
